import ApiRequest from './ApiRequest';

class ContactApi extends ApiRequest {
  sendContactForm(data) {
    return this.post('contacts', data)
      .then(response => response.data)
      .catch(error => console.log(error)); // eslint-disable-line no-console
  }
}

export default ContactApi;



// WEBPACK FOOTER //
// ./src/api/ContactApi.js